const initBanner = () => {
    const gdprBanner = document.getElementById("cookieNotice-v3");
    const saleOfDataFlexWrap = document.getElementById("saleOfData");
    const mainContent = document.getElementById("MainContent");
    const headerContent = document.getElementById("shopify-section-ve-header");
    const body = document.querySelector("body");
    const buttonRow = document.querySelector(".button-row");
    const gdprBannerInputs = Array.from(gdprBanner.querySelectorAll("input[type='checkbox']:not([name='necessary'])"));

    const customerPrivacy = window.Shopify.customerPrivacy;
    const saleOfDataRegion = customerPrivacy.saleOfDataRegion();
    let currentVisitorConsent = customerPrivacy.currentVisitorConsent();

    const callback = () => { }

    if (gdprBanner) {
        gdprBanner.style.cssText = `
            display: block;
            opacity: 100%;
            pointer-events: auto;
        `;
    }

    if (mainContent && headerContent) {
        mainContent.style.cssText = `
            transition: filter 0.3s ease-in-out;
            filter: blur(3px);
            pointer-events: none;
        `;

        headerContent.style.cssText = `
            transition: filter 0.3s ease-in-out;
            filter: blur(3px);
            pointer-events: none;
        `;

        body.style.cssText = `
            overflow: hidden;
        `;
    }

    if (!saleOfDataRegion) {
        saleOfDataFlexWrap.style.display = "none";
    }

    if (gdprBannerInputs) {
        gdprBannerInputs.forEach(checkbox => {
            checkbox.checked = currentVisitorConsent[checkbox.name] === 'yes';
        });
    }

    if (buttonRow) {
        buttonRow.addEventListener("click", function (e) {
            e.preventDefault();
            var submitType = e.target.getAttribute("data-submit-type");

            if (submitType) {
                var actions = {
                    'deny': function () {
                        gdprBannerInputs.forEach((checkbox) => {
                            checkbox.checked = false;
                        });
                        customerPrivacy.setTrackingConsent(
                            {
                                "analytics": false,
                                "marketing": false,
                                "preferences": false,
                                "sale_of_data": false
                            },
                            callback
                        );
                    },
                    'allow-selection': function () {
                        const checkedValues = gdprBannerInputs
                            .filter(checkbox => checkbox.checked)
                            .map(checkbox => checkbox.name);
                        customerPrivacy.setTrackingConsent(
                            {
                                "analytics": checkedValues.includes("analytics"),
                                "marketing": checkedValues.includes("marketing"),
                                "preferences": checkedValues.includes("preferences"),
                                "sale_of_data": checkedValues.includes("sale_of_data")
                            },
                            callback
                        );
                    },
                    'allow-all': function () {
                        gdprBannerInputs.forEach((checkbox) => {
                            checkbox.checked = true;
                        });
                        customerPrivacy.setTrackingConsent(
                            {
                                "analytics": true,
                                "marketing": true,
                                "preferences": true,
                                "sale_of_data": true
                            },
                            callback
                        );
                    }
                };
                if (actions[submitType]) {
                    actions[submitType]();
                }
            }

            setTimeout(() => {
                mainContent.style.filter = "blur(0px)";
                mainContent.style.pointerEvents = "auto";
                headerContent.style.filter = "blur(0px)";
                headerContent.style.pointerEvents = "auto";
                body.style.overflow = "unset";
                gdprBanner.style.transform = "translateX(-50%) translateY(250%)";
            }, 250);

            setTimeout(() => {
                gdprBanner.style.display = "none";
            }, 1500);
        });
    }

    document.addEventListener("visitorConsentCollected", (event) => {
        const detail = event.detail;

        for (const key in detail) {
            if (detail.hasOwnProperty(key) && detail[key]) {
                switch (key) {
                    case "marketingAllowed":
                        // console.log('marketingAllowed');
                        break;

                    case "saleOfDataAllowed":
                        // console.log('saleOfDataAllowed');
                        break;

                    case "analyticsAllowed":
                        // console.log('analyticsAllowed');
                        break;

                    case "preferencesAllowed":
                        // console.log('preferencesAllowed');
                        break;

                    case "firstPartyMarketingAllowed":
                        // console.log('firstPartyMarketingAllowed');
                        break;

                    case "thirdPartyMarketingAllowed":
                        // console.log('thirdPartyMarketingAllowed');
                        break;
                }
            }
        }
    });

}

// Init
window.Shopify.loadFeatures(
    [
        {
            name: "consent-tracking-api",
            version: "0.1",
        },
    ],
    (error) => {
        if (error) {
            throw error;
        }
        if (window.Shopify.customerPrivacy.shouldShowGDPRBanner()) {
            initBanner();
        }
    }
);
document.getElementById("buttonUpdateCookies").addEventListener('click', () => {
    initBanner();
})